export type CsFeature = {
  id: string;
  label: string;
  color: string;
  defaultSelected?: boolean;
};

const COLOR_AZURE_BLUE = '#1976d2';
const COLOR_FOREST_GREEN = '#2e7d32';
const COLOR_DEEP_ORANGE = '#e65100';
const COLOR_TEAL = '#00897b';
const COLOR_INDIGO = '#3949ab';
const COLOR_ROSE = '#c2185b';
const COLOR_AMBER = '#f9a825';
const COLOR_CYAN = '#0097a7';
const COLOR_RED = '#d32f2f';
const COLOR_LIME = '#7cb342';
const COLOR_BLUE_GREY = '#546e7a';
const COLOR_DEEP_PURPLE = '#5e35b1';
const COLOR_PINK = '#ad1457';
const COLOR_GREEN = '#43a047';
const COLOR_BROWN = '#6d4c41';
const COLOR_LIGHT_BLUE = '#0288d1';
const COLOR_ORANGE = '#fb8c00';
const COLOR_PURPLE = '#8e24aa';
const COLOR_GREY = '#616161';
const COLOR_YELLOW_BROWN = '#827717';
const COLOR_DARK_TEAL = '#00695c';
const COLOR_BLUE = '#1565c0';
const COLOR_DARK_RED = '#b71c1c';
const COLOR_SLATE = '#455a64';
export const COLOR_WHITE = '#fff';
export const MAX_SELECTED_CS_FEATURES = 20;

/**
 * Registry of trackable CS features.
 * To add a new feature: append one entry here and ensure the owning service
 * fires a `cs_agent_feature_used` Snowplow event with the matching featureId.
 */
export const CS_FEATURES: CsFeature[] = [
  {
    id: 'sms-verify',
    label: 'SMS Verification',
    color: COLOR_AZURE_BLUE,
    defaultSelected: true,
  },
  {
    id: 'ai-call-summary',
    label: 'AI Call Summary',
    color: COLOR_FOREST_GREEN,
    defaultSelected: true,
  },
  {
    id: 'customer-information',
    label: 'Customer Information',
    color: COLOR_DEEP_ORANGE,
  },
  {
    id: 'booking-information',
    label: 'Booking Information',
    color: COLOR_TEAL,
  },
  {
    id: 'customer-quotes',
    label: 'Customer Quotes',
    color: COLOR_INDIGO,
  },
  {
    id: 'lesa-chat-history',
    label: 'LESA Chat History',
    color: COLOR_ROSE,
  },
  {
    id: 'related-ticket-information',
    label: 'Related Ticket Information',
    color: COLOR_AMBER,
  },
  {
    id: 'interaction-history',
    label: 'Interaction History',
    color: COLOR_CYAN,
  },
  {
    id: 'looker-dashboard',
    label: 'Looker Dashboard',
    color: COLOR_RED,
  },
  {
    id: 'system-information',
    label: 'System Information',
    color: COLOR_LIME,
  },
  {
    id: 'csat',
    label: 'CSAT',
    color: COLOR_BLUE_GREY,
  },
  {
    id: 'email-view',
    label: 'Email View',
    color: COLOR_DEEP_PURPLE,
  },
  {
    id: 'customer-review',
    label: 'Customer Review',
    color: COLOR_PINK,
  },
  {
    id: 'genesys-call-summary',
    label: 'Genesys Call Summary',
    color: COLOR_GREEN,
  },
  {
    id: 'agent-handover-script',
    label: 'Agent Handover Script',
    color: COLOR_BROWN,
  },
  {
    id: 'email-forward',
    label: 'Email Forward',
    color: COLOR_LIGHT_BLUE,
  },
  {
    id: 'customer-transactional-emails',
    label: 'Customer Transactional Emails',
    color: COLOR_ORANGE,
  },
  {
    id: 'recent-searches-and-abandoned-carts',
    label: 'Recent Searches & Abandoned Carts',
    color: COLOR_PURPLE,
  },
  {
    id: 'vendor-information',
    label: 'Vendor Information',
    color: COLOR_GREY,
  },
  {
    id: 'support-actions-link-booking',
    label: 'Support Actions: Link Booking',
    color: COLOR_YELLOW_BROWN,
  },
  {
    id: 'escalations-and-transfers-transfer-team-lead',
    label: 'Escalations & Transfers: Transfer to Team Lead',
    color: COLOR_DARK_TEAL,
  },
  {
    id: 'escalations-and-transfers-transfer-department',
    label: 'Escalations & Transfers: Transfer Department',
    color: COLOR_BLUE,
  },
  {
    id: 'escalations-and-transfers-atl-escalation',
    label: 'Escalations & Transfers: ATL Escalation',
    color: COLOR_DARK_RED,
  },
  {
    id: 'escalations-and-transfers-cm-escalation',
    label: 'Escalations & Transfers: CM Escalation',
    color: COLOR_SLATE,
  },
];

export const DEFAULT_CS_FEATURE_IDS = CS_FEATURES.filter((feature) => feature.defaultSelected).map(
  (feature) => feature.id,
);

export const CS_FEATURE_MAP: Record<string, CsFeature> = Object.fromEntries(
  CS_FEATURES.map((feature) => [feature.id, feature]),
);
